import script from "./MenueDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./MenueDefault.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/modules/MenueDefault.css?vue&type=style&index=0&id=61fe34dc&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61fe34dc"]])

export default __exports__